// extracted by mini-css-extract-plugin
module.exports = {"root":"SegmentedControl_root__PnYjD"};